module.exports = __webpack_public_path__ + "media/fr_fr_s1_Jerome.7bba1787.mp3";